import {environment} from '@/config/environment';

export const appConfig = {
    baseUrl: environment.VITE_BASE_URL ?? '',
    isHybridApp: __IS_HYBRID_APP__,
    get isLocalDevelopment(): boolean {
        // Check if current hostname is a local development URL (*.local domains)
        return (
            typeof window !== 'undefined' &&
            window.location.hostname.endsWith('.local') &&
            !!environment.VITE_DEV_BASE_URL
        );
    },
    get isZrokShare(): boolean {
        // Check if current hostname is a Zrok share URL (*.share.deskly.live)
        // These are used for sharing local development environments
        return (
            typeof window !== 'undefined' && window.location.hostname.endsWith('.share.deskly.live')
        );
    },
    defaultApiRequestHeaders: getDefaultRequestHeaders(),
};

function getDefaultRequestHeaders() {
    const headers: Record<string, string> = {
        'client-identifier': __IS_HYBRID_APP__ ? 'hybrid-app' : 'webapp',
    };

    if (import.meta.env.MODE === 'app') {
        headers['ngrok-skip-browser-warning'] = 'true';
    }

    return headers;
}
